import { useCallback } from "react";
import { Edit, useNotify, useRedirect, useRefresh } from "react-admin";
import { useUploadHook } from "../../utils/upload.hook";
import { FormsForm } from "./component/forms.form";

const FormsEdit = (props) => {
    const upload = useUploadHook()
    const notify = useNotify();
    const redirect = useRedirect();
    const refresh = useRefresh();

    const onSuccess = ({ data }) => {
        notify('Fomulário criado com sucesso')
        redirect('/forms', undefined, {}, {}, { data })
        refresh()
    }

    const onTransform = useCallback(async (data) => {
        if (data.attachment) {
            const attachment = await upload.uploadFile(data.attachment.rawFile, 'forms')
            return { ...data, attachment: attachment?.length ? attachment[0] : attachment };
        }
        return data;
    }, [upload])


    return (
        <Edit
            mutationMode="pessimistic"
            transform={onTransform}
            onSuccess={onSuccess}
            {...props}

        >
            <FormsForm />
        </Edit>
    )
}

export default FormsEdit;